import type { MouseEvent } from 'react'
import { type FC, useCallback, useMemo } from 'react'

import { VaultMediaType } from '@api'

import { classNames } from '@/utils/helpers'

import { MEDIA_TYPE_OPTIONS } from './constants'

interface Props {
  onSelect: (type: VaultMediaType) => void
  selected: VaultMediaType
  types?: VaultMediaType[]
}

export const MediaTypeFilter: FC<Props> = ({ onSelect, selected, types }) => {
  const filteredOptions = useMemo(
    () =>
      types
        ? MEDIA_TYPE_OPTIONS.filter(
            ({ value }) =>
              types.includes(value) || value === VaultMediaType.ALL,
          )
        : MEDIA_TYPE_OPTIONS,
    [types],
  )

  const handleOptionClick = useCallback(
    (event: MouseEvent<HTMLDivElement>) => {
      const value = event.currentTarget.dataset.optionValue as VaultMediaType

      if (value) {
        onSelect(value)
      }
    },
    [onSelect],
  )

  return (
    <div className="flex items-center">
      {filteredOptions.map(({ value, label }) => (
        <div
          key={value}
          data-option-value={value}
          className={classNames(
            'text-text-default mr-2 cursor-pointer rounded-[100px] px-3 py-1 text-sm font-medium transition duration-200 last:mr-0',
            {
              'bg-primary-500 dark:bg-primary-500 text-white':
                selected === value,
              'bg-secondary-50 hover:bg-secondary-200 dark:bg-secondary-600 dark:hover:bg-primary-800':
                selected !== value,
            },
          )}
          onClick={handleOptionClick}
        >
          {label}
        </div>
      ))}
    </div>
  )
}
